import { ChangeEvent, ReactElement, useCallback, useContext, useState } from "react"
import { FormContext } from "../../context/contact/contact-context"
import { FormContextProps } from "../../context/contact/contact-context-props"
import { InputProps } from "./input-props"
import * as S from './input-style'

export function Input ({ label, type, onChange, ...props }: InputProps): ReactElement {
  const { content, errors } = useContext<FormContextProps>(FormContext)
  const [dirty, setDirty] = useState<boolean>(false)
  const handleChange = useCallback((evt: ChangeEvent<HTMLInputElement>) => {
    setDirty(true)
    if (onChange) onChange(evt)
  }, [onChange])
  return <div>
    <S.Container className={errors[props.id] && dirty ? 'has-error' : ''}>
      <S.Label htmlFor={props.id}>{label}</S.Label>
      <S.Input {...props} type={type || "text"} value={content[props.id]} onChange={handleChange} />
    </S.Container>
    <S.Error>{dirty && errors[props.id]}</S.Error>
  </div>
}